(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // Parallax scroll handler
    function initParallax() {
      const heroSections = document.querySelectorAll('.hero[data-parallax="true"]');
      if (!heroSections.length) return;

      // Use IntersectionObserver to only run parallax when visible
      const observerOptions = {
        root: null,
        rootMargin: '100px 0px',
        threshold: 0
      };

      const visibleSections = new Set();

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            visibleSections.add(entry.target);
          } else {
            visibleSections.delete(entry.target);
          }
        });
      }, observerOptions);

      heroSections.forEach(section => observer.observe(section));

      let ticking = false;

      function updateParallax() {
        visibleSections.forEach(section => {
          const mediaWrapper = section.querySelector('.hero__media-wrapper--parallax');
          if (!mediaWrapper) return;

          const intensity = parseFloat(section.dataset.parallaxIntensity) || 30;
          const rect = section.getBoundingClientRect();
          const windowHeight = window.innerHeight;

          // Calculate how far through the viewport the section is
          // 0 = section top is at viewport bottom, 1 = section bottom is at viewport top
          const sectionHeight = rect.height;
          const scrollProgress = (windowHeight - rect.top) / (windowHeight + sectionHeight);

          // Clamp between 0 and 1
          const clampedProgress = Math.max(0, Math.min(1, scrollProgress));

          // Map to translation range: from +intensity to -intensity
          const translateY = intensity - (clampedProgress * intensity * 2);

          mediaWrapper.style.transform = 'translate3d(0, ' + translateY + 'px, 0)';
        });

        ticking = false;
      }

      function onScroll() {
        if (!ticking && visibleSections.size > 0) {
          ticking = true;
          requestAnimationFrame(updateParallax);
        }
      }

      // Prefer passive scroll listener for performance
      window.addEventListener('scroll', onScroll, { passive: true });

      // Initial position
      requestAnimationFrame(updateParallax);

      // Also update on resize
      let resizeTimer;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          requestAnimationFrame(updateParallax);
        }, 100);
      }, { passive: true });
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initParallax);
    } else {
      initParallax();
    }

    // Re-initialize for Shopify theme editor
    if (Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', initParallax);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
